import { ROUTE_NAMES } from '@/lib/enums';
import { ROLE_ADMIN, ROLE_STAFF_USER } from '@/util/roles';

export const routes = [
	{
		path: 'profiles',
		meta: {
			requireAuth: true,
			breadcrumb: 'Profiles',
		},
		children: [
			{
				path: '',
				name: ROUTE_NAMES.DEPOT.PROFILES.OVERVIEW,
				component: () => {
					return import('@/views/depot/profiles/Overview.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: '',
				},
			},
			{
				path: 'view-profiles',
				name: ROUTE_NAMES.DEPOT.PROFILES.VIEW_PROFILES,
				component: () => {
					return import('@/views/depot/profiles/View-Profiles.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'View Profiles',
				},
			},
			{
				// A report about profiles rather than a section of its own: it
				// lists the sites linked to exactly one profile.
				//
				// Sits beside the `:profile_uuid` child below, so `/depot/profiles/channels`
				// has two candidate matches. Vue Router ranks a static segment above a
				// dynamic one, so this wins regardless of declaration order.
				path: 'channels',
				name: ROUTE_NAMES.DEPOT.PROFILES.CHANNELS,
				component: () => {
					return import('@/views/depot/profiles/Channels.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'Single Channels',
				},
			},
			{
				path: 'add-profile',
				name: ROUTE_NAMES.DEPOT.PROFILES.ADD_PROFILE,
				component: () => {
					return import('@/views/depot/profiles/Add-Profile.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'Add Profile',
					minRole: ROLE_STAFF_USER,
				},
			},
			{
				path: 'bulk-add-profiles',
				name: ROUTE_NAMES.DEPOT.PROFILES.BULK_ADD_PROFILES,
				component: () => {
					return import('@/views/depot/profiles/Bulk-Add-Profiles.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'Bulk Add Profiles',
					// A bulk write, so admins only, where single Add Profile is open to
					// staff users.
					minRole: ROLE_ADMIN,
				},
			},
			{
				path: 'enrich-profiles-list',
				name: ROUTE_NAMES.DEPOT.PROFILES.ENRICH_PROFILES_LIST,
				component: () => {
					return import('@/views/depot/profiles/Enrich-Profiles-List.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'Enrich Profiles List',
					minRole: ROLE_ADMIN,
				},
			},
			{
				path: 'rebuild-review-counts',
				name: ROUTE_NAMES.DEPOT.PROFILES.REBUILD_REVIEW_COUNTS,
				component: () => {
					return import('@/views/depot/profiles/Rebuild-Review-Counts.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: 'Rebuild Review Counts',
					// Estate-wide maintenance write, gated level with the other
					// estate-wide runs: Fix Site Naming, Dedupe Sites, Sync Profile
					// Ownership. `Depot.Admin` is the highest gate any route should
					// carry; `Depot.Staff.Admin` outranks it but nothing requires it.
					minRole: ROLE_ADMIN,
				},
			},
			{
				path: ':profile_uuid',
				meta: {
					requireAuth: true,
				},
				children: [
					{
						path: '',
						name: ROUTE_NAMES.DEPOT.PROFILE.VIEW_PROFILE,
						component: () => {
							return import('@/views/depot/profile/View-Profile.vue');
						},
						meta: {
							requireAuth: true,
							breadcrumb: 'Profile',
						},
					},
					{
						path: 'reviews',
						name: ROUTE_NAMES.DEPOT.PROFILE.VIEW_REVIEWS,
						component: () => {
							return import('@/views/depot/profile/View-Reviews.vue');
						},
						meta: {
							requireAuth: true,
							breadcrumb: 'Reviews',
						},
					},
				],
			},
		],
	},
];
